import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';

/* ─── Menu Node ──────────────────────────────────────────── */
export const MenuNode = memo(({ data, selected }) => (
    <div className={`bot-node menu-node ${selected ? 'selected' : ''} ${data.isRoot ? 'root-node' : ''}`}>
        <Handle type="target" position={Position.Top} className="node-handle" isConnectable={false} />
        <div className="node-header">
            <span className="node-type-badge menu">Menu</span>
            {data.isRoot && <span className="root-badge">Entry</span>}
        </div>
        <div className="node-label">{data.label || 'Untitled'}</div>
        {data.message && (
            <div className="node-preview">{data.message.substring(0, 60)}{data.message.length > 60 ? '...' : ''}</div>
        )}
        <div className="node-meta">{data.presentation === 'list' ? 'List message' : data.presentation === 'buttons' ? 'Reply buttons' : 'Text only'}</div>
        {data.optionCount > 0 && (
            <div className="node-meta">{data.optionCount} option{data.optionCount !== 1 ? 's' : ''}</div>
        )}
        <Handle type="source" position={Position.Bottom} className="node-handle" isConnectable={false} />
    </div>
));

/* ─── Message Node ───────────────────────────────────────── */
export const MessageNode = memo(({ data, selected }) => (
    <div className={`bot-node message-node ${selected ? 'selected' : ''} ${data.isRoot ? 'root-node' : ''}`}>
        <Handle type="target" position={Position.Top} className="node-handle" isConnectable={false} />
        <div className="node-header">
            <span className="node-type-badge message">Message</span>
            {data.isRoot && <span className="root-badge">Entry</span>}
        </div>
        <div className="node-label">{data.label || 'Untitled'}</div>
        {data.message && (
            <div className="node-preview">{data.message.substring(0, 60)}{data.message.length > 60 ? '...' : ''}</div>
        )}
        <Handle type="source" position={Position.Bottom} className="node-handle" isConnectable={false} />
    </div>
));

/* ─── Handoff Node ───────────────────────────────────────── */
export const HandoffNode = memo(({ data, selected }) => (
    <div className={`bot-node handoff-node ${selected ? 'selected' : ''} ${data.isRoot ? 'root-node' : ''}`}>
        <Handle type="target" position={Position.Top} className="node-handle" isConnectable={false} />
        <div className="node-header">
            <span className="node-type-badge handoff">Handoff</span>
            {data.isRoot && <span className="root-badge">Entry</span>}
        </div>
        <div className="node-label">{data.label || 'Untitled'}</div>
        <div className="node-preview">Transfers to human agent</div>
        <Handle type="source" position={Position.Bottom} className="node-handle" isConnectable={false} />
    </div>
));

MenuNode.displayName = 'MenuNode';
MessageNode.displayName = 'MessageNode';
HandoffNode.displayName = 'HandoffNode';
